import Vue from 'vue';
import sanctum from '../http/requests/auth/sanctum';
import userModifier from '../modifiers/pengguna';
export default (to, from, next) => {
  if (!sanctum.isAuth()) {
    next({ name: 'login' });
    return false;
  }
  Vue.prototype.$user = userModifier(sanctum.getUser());
};
